import styled from '@emotion/styled'

export const InputWrapper = styled.div`
  width: 70px;
`

export const ButtonWrapper = styled.div`
  button {
    padding: 1px 6px;
  }
`
